// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__1UT8-","spinner":"LoadingOverlay_spinner__AS9MZ","spin":"LoadingOverlay_spin__325pN"};